import { React, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router";

import {
  get_more_restrict_kid_channel,
  get_restrict_kid_channel,
} from "../../../redux/features/ktkSlice";
import ktkRestrictService from "../../../services/ktkRestrictService";
import usersService from "../../../services/userService";

import { Button } from "../../commonComponents/Buttons";
import { TripleGrid } from "../../commonComponents/Grids";

import {
  ViewsIcon,
  UnlikedIcon,
  LikedIcon,
  NoAvatar,
  ReplyButton3,
} from "../../../assets";
import "./kidsTeachKids.scss";

function RestrictKidChannel() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();

  const userInfo = useSelector((state) => state?.user?.userInfo);
  const [kidChannel, setKidChannel] = useState();
  const [kidChannelVideos, setKidChannelVideos] = useState();

  useEffect(() => {
    if (!kidChannel) {
      let args = {
        userId: params?.userId,
        channelId: params?.channelId,
      };
      dispatch(get_restrict_kid_channel(args)).then((result) => {
        setKidChannel(result?.payload);
        setKidChannelVideos(result?.payload?.data?.videos);
      });
    }
  }, [kidChannel, dispatch, params, userInfo]);

  function loadMore() {
    let args = {
      userId: params?.userId,
      channelId: params?.channelId,
      page: kidChannel?.next_page,
    };
    dispatch(get_more_restrict_kid_channel(args)).then((result) => {
      setKidChannel(result?.payload);
      setKidChannelVideos(
        kidChannelVideos.concat(result?.payload?.data?.videos)
      );
    });
  }

  function restrictHandler(videoId) {
    ktkRestrictService
      .postRestrictChannelVideo(params?.userId, params?.channelId, videoId)
      .then((result) => {
        let tempArray = [...kidChannelVideos];
        const index = kidChannelVideos.findIndex(
          (item) => item?.id === videoId
        );
        tempArray[index] = {
          ...tempArray[index],
          restricted: result?.data?.result?.restricted,
        };

        setKidChannelVideos(tempArray);
      });
  }

  function renderOwnerInfo() {
    if (kidChannel && kidChannel?.data?.user?.age) {
      return `${kidChannel?.data?.user?.name}, ${kidChannel?.data?.user?.age} ${t("years")}`;
    } else if (kidChannel && !kidChannel?.data?.user?.age) {
      return `${kidChannel?.data?.user?.name}, ? ${t("years")}`;
    }
  }

  return (
    <>
      <main className="ktkBg">
        <Button
          label={t("back")}
          iconClassName="hasIcon--chevron-left"
          viewType="backButton"
          onClick={() => navigate(-1)}
        />
        <section className="withAsideArticle">
          <aside>
            <section className="channelInfo">
              <section className="mainInfo">
                <img
                  className="userImage"
                  src={
                    kidChannel?.data?.channel_avatar
                      ? kidChannel?.data?.channel_avatar
                      : NoAvatar
                  }
                  alt="User Name"
                />

                <div className="userInfo">
                  <div className="textInfo">
                    <p className="ownerInfo">{renderOwnerInfo()}</p>
                    <p className="channelTitle">{kidChannel?.data?.title}</p>
                  </div>
                </div>
              </section>

              <p className="channelDescription">
                {kidChannel?.data?.description}
              </p>
            </section>
          </aside>

          <TripleGrid
            title={`${t("restrictVideoTo")} ${
              kidChannel && kidChannel?.kid_name
            }`}
            viewType="middle"
            ifPagination={kidChannel?.next_page ? true : false}
            paginationClick={loadMore}
          >
            {kidChannelVideos &&
              kidChannelVideos.map((item) => {
                return (
                  <li key={item?.id}>
                    <div className="videoCard">
                      <div className="videoLinkRestrict">
                        <img
                          className="videoCardImage"
                          src={item?.cover_image_link}
                          alt="VideoTitle"
                        />
                        <div
                          className={`manageVideos ${
                            item?.restricted && "isRestricted hasIcon--disable"
                          }`}
                        >
                          <ul className="restrictBtnList">
                            <li>
                              <Button
                                label={item?.restricted ? t("allow") : t("restrict")}
                                iconClassName={
                                  item?.restricted
                                    ? "hasIcon--check-circle"
                                    : "hasIcon--disable"
                                }
                                customClassName="restrict-btn asLink"
                                onClick={() => restrictHandler(item?.id)}
                              />
                            </li>
                            <li>
                              <NavLink
                                to={`/kids-teach-kids/channels/${params?.userId}/channel/${params?.channelId}/video/${item?.id}`}
                                className="hasIcon--ktk-restrict"
                              >
                                {t("watch")}
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <p className="videoTitle">{item?.title}</p>
                      <div className="infoBlock">
                        <div className="leftBlock">
                          <div className="activityCounter">
                            <img
                              className="activityIcon"
                              src={ViewsIcon}
                              alt={t("views")}
                            />
                            <p className="activityTxt">{item?.views}</p>
                          </div>
                          <div className="activityCounter">
                            <Button viewType="clildrenBtn">
                              <img
                                className="activityIcon"
                                src={
                                  item?.additional_info?.liked
                                    ? LikedIcon
                                    : UnlikedIcon
                                }
                                alt={t("likes")}
                              />
                            </Button>
                            <p className="activityTxt">{item?.likes}</p>
                          </div>
                          <div className="activityCounter">
                            <img
                              className="activityIcon"
                              src={ReplyButton3}
                              alt={t("views")}
                            />
                            <p className="activityTxt">{item?.comment_count}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                );
              })}
          </TripleGrid>
        </section>
      </main>
      {userInfo && userInfo?.account_level === "manager" && (
        <section className="manageRestrictSubmit">
          <ul>
            <li>
              {t("restrictLabelTo")}{" "}
              <strong>{kidChannel?.kid_name}</strong>:
            </li>
            <li>
              <Button
                label={t("done")}
                viewType="mainBtn"
                onClick={() => usersService.goToMonolith("accounts/readers/")}
              />
            </li>
          </ul>
        </section>
      )}
    </>
  );
}

export default RestrictKidChannel;
